import './style.css';
import { useState } from "react";

export const Form = ({listTransactions, setListTransactions, setIsFiltered, setStatusAllButton, setStatusEntryButton, setStatusOutButton}) => {

    const [valueInput, setValueInput] = useState(0);
    const [descriptionInput, setDescriptionInput] = useState(0);
    const [selectInput, setSelectInput] = useState('Entrada');

    function handleSubmit(event) {

        const transaction = {

            value: Number(valueInput), 
            description: descriptionInput,
            type: selectInput

        };

        event.preventDefault();
        console.log(transaction);

        setListTransactions([...listTransactions, transaction]);

    }

    return (

        <form onSubmit={handleSubmit} className="form">

            <div className="description-example">
                <label htmlFor="description">Descrição</label>
                <input type='text' name='description' placeholder='Digite uma descrição' onChange={(event) => setDescriptionInput(event.target.value)}/>
                <p>Ex: Compra de roupas</p>
            </div>

            <div className="value-select">

                <div className="value">
                    <label htmlFor="value">Valor</label>
                    <input type='number' name='value' placeholder='Digite o valor' onChange={(event) => setValueInput(event.target.value)}/>
                </div>

                <div className="type">
                    <label htmlFor="entryOrOut">Tipo do Valor</label>
                    <select name="entryOrOut" onChange={(event) => setSelectInput(event.target.value)}>
                        <option value="Entrada">Entrada</option>
                        <option value="Saída">Saída</option>
                    </select>
                </div>

            </div>

            <button type="submit" onClick={()=> {
            
                setIsFiltered(false)
                setStatusAllButton(true)
                setStatusEntryButton(false)
                setStatusOutButton(false)

            }}>Inserir Valor</button>

        </form>

    );

}